module.exports = __webpack_public_path__ + "static/julie-miller-phipps-ac5c29f5f98b0c39c0f0b630ee91ba2e.jpg";